export default __webpack_public_path__ + "static/media/sadmsCoverOptionalImage.e66d5e34.png";